import { keepPreviousData, useQuery } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';

export type ConnectivityEmailListParams = Parameters<typeof VendorsService.listConnectivityEmailProcessing>[0];

export const connectivityEmailProcessingQueryKeys = {
  all: ['connectivity', 'emailProcessing'] as const,
  list: (filters?: ConnectivityEmailListParams) =>
    [...connectivityEmailProcessingQueryKeys.all, 'list', filters ?? {}] as const,
};

export function useGetConnectivityEmailProcessing(filters?: ConnectivityEmailListParams) {
  return useQuery({
    queryKey: connectivityEmailProcessingQueryKeys.list(filters),
    queryFn: ({ signal }) => VendorsService.listConnectivityEmailProcessing(filters, { signal }),
    placeholderData: keepPreviousData,
  });
}
